import React from 'react';

function Content() {

  return (
    <div className="content">
      <h2>Copyright Infringement Notification</h2> 
      <p>If you believe that your copyright-protected work was posted on 
        Swaphead app without authorization, you may submit a copyright infringement notification.</p> 
      
      <p><strong>The notification must include the following:</strong></p>
      <ul>
        <li>physical address, email and phone number, so that we can contact you.</li>
        <li>Complete description of your work that you believe has been infringed.</li>
        <li>Identifying location of the allegedly infringing work.</li>
        <li>A statement that you have a good faith belief that use of the material in the manner complained of is not authorized by the copyright owner, its agent, or law.</li>
        <li>A statement, made under penalty of perjury, that the above information is accurate, and that you are the copyright owner or are authorized to act on behalf of the copyright owner.</li>
        <li>The physical or electronic signature of the copyright owner or an authorized representative of the copyright owner. To satisfy this requirement, you may type your full legal name (not that of a company) at the bottom of your notification.</li>
      </ul>
      <p>Submit the above information to us: swapheadd@gmail.com</p>
    </div>
  );
}

export default Content;